import React, { useEffect, useState } from "react";
import DashboardGreeting from "../DashboardGreeting";

import { Calendar as MonthCalendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-cyan/theme.css";

import { useStateContext } from "../../contexts/ContextProvider";

import "../leaveOverview.css";

import moment from "moment";
import DashboardService from "../../services/dashboard.service";
import CommonLeaveOverview from "../common/CommonLeaveOverview";
import { useLocation } from "react-router-dom";

const LeaveOverview = ({ user }) => {
  const navHeading = "Leave Overview";

  const [date, setDate] = useState(new Date());

  const [year, setYear] = useState("");

  const location = useLocation();

  const currentDate = new Date();

  const [leaveData, setLeaveData] = useState({
    lop: "0",
    paidleave: "0",
    goodwill: "0",
    totalTakenLeaves: "0",
    yealrlyBalanceLeaves: "0",
    totalPaidTakenLeaves: "0",
    yearlyAllocatedleaves: "0",
    queterBalance: "0",
  });

  const fetchEmpLeaveOverview = (currentYear) => {
    const payload = {
      empId: location.pathname === "/empLeaveHistory" ? "" : user && user.empid,
      year: currentYear.toString(),
    };

    DashboardService.getEmpLeaveOverview(payload)
      .then((resp) => {
        setLeaveData(resp.data);
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    const currentYear = moment(new Date()).format("YYYY");
    if (currentYear) {
      fetchEmpLeaveOverview(currentYear);
    }
  }, []);

  const handleDateChange = (e) => {
    setDate(e.value);
    const x = moment(new Date(e.value)).format("YYYY");
    // console.log(x);
    setYear(x);
    fetchEmpLeaveOverview(x);
  };

  return (
    <>
      <div className="dashboard-container">
        <DashboardGreeting navHeading={navHeading} user={user} />
        <div className="filterBar mb-5">
          <div className="filter">
            <div className="month-filter">
              <MonthCalendar
                value={date}
                onChange={handleDateChange}
                view="year"
                dateFormat="yy"
                style={{ height: "45px" }}
                showIcon
                maxDate={currentDate}
              />
            </div>
          </div>
        </div>
        <CommonLeaveOverview leaveData={leaveData} year={year} />
      </div>
    </>
  );
};

export default LeaveOverview;
